<template>
  <v-dialog v-model="dialog" :persistent="true" max-width="40%">
    <v-form ref="formJustificativa" v-model="valido"  v-on:submit.prevent lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">{{ title || $t('label.informe_justificativa') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-row>
              <v-col cols="12">
                <v-text-field :label="`${$t('label.justificativa')} *`"
                              :rules="[rules.required]"
                              v-if="!bloquearJustificativa"
                              required v-model="justificativa"
                              v-on:keyup.enter="afirmativo()">
                </v-text-field>
                <span v-else>
                  {{ justificativa }}
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      <v-card-actions class="d-flex">
        <div
          v-if="!isJustificativaAlterada && this.justificativaOriginal.length > 0"
          class="info-alteracao pl-2 flex-grow-1"
        >
          <span v-html="$t('message.dados_alteracao_valores_apuracao', {
            dataAlteracao: dtaAlteracaoValorApuracao,
            horaAlteracao: horaAlteracaoValorApuracao,
            nomeUsuarioAlteracao: nomeUsuarioAlteracaoValorApuracao
          })"></span>
        </div>
        <div
          v-if="isJustificativaAlterada && this.justificativaOriginal.length > 0"
          class="info-alteracao pl-2 flex-grow-1"
        >
          <span v-html="$t('message.dados_alteracao_valores_apuracao_antes_de_salvar', {
            nomeUsuarioAlteracao: nomeUsuarioAlteracaoValorApuracao
          })"></span>
        </div>

        <div class="d-flex justify-end flex-grow-1">
          <v-btn v-if="!isNovoValor" color="primary" text @click="bloquearJustificativa ? close() : cancelar()">
            {{ $t('label.cancelar') }}
          </v-btn>

          <v-btn color="primary" text v-if="!bloquearJustificativa"
              @click="afirmativo()">
            {{ textoBotaoAfirmativo ? textoBotaoAfirmativo : $t('label.ok') }}
          </v-btn>
        </div>
      </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModalJustificativa',
  props: {
    title: '',
    textoBotaoAfirmativo: null,
    notaDebito: {
      type: Object,
      default: () => ({}),
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
  },
  data() {
    return {
      valido: false,
      dialog: false,
      bloquearJustificativa: true,
      justificativa: '',
      rules: {
        required: (value) => (!!value && value.trim().length > 0) || this.$t('message.campo_obrigatorio'),
      },
      isNovoValor: false,
      nomeUsuarioAlteracaoValorApuracao: '',
      dtaAlteracaoValorApuracao: '',
      horaAlteracaoValorApuracao: '',
      justificativaOriginal: '',
      indTemJustificativaSalva: false,
      isJustificativaAlterada: false,
    };
  },
  methods: {
    open(isNovoValor) {
      this.isNovoValor = isNovoValor;
      this.bloquearJustificativa = this.somenteLeitura;
      this.indTemJustificativaSalva = this.notaDebito.indTemJustificativaSalva;
      this.justificativa = this.notaDebito.justificativa;
      this.justificativaOriginal = this.justificativa;
      if (this.indTemJustificativaSalva && (this.justificativa === this.notaDebito.justificativaOriginal)) {
        this.isJustificativaAlterada = false;
      } else if ((this.indTemJustificativaSalva && (this.justificativa !== this.notaDebito.justificativaOriginal))
        || (!this.indTemJustificativaSalva && this.justificativaOriginal.length > 0)) {
        this.isJustificativaAlterada = true;
      }
      this.nomeUsuarioAlteracaoValorApuracao = this.notaDebito.nomeUsuarioAlteracaoValorApuracao ? this.notaDebito.nomeUsuarioAlteracaoValorApuracao
        : this.usuarioLogado.nome;
      if (this.notaDebito.dtaAlteracaoValorApuracao) {
        const partes = this.notaDebito.dtaAlteracaoValorApuracao.split(' ');
        this.dtaAlteracaoValorApuracao = partes[0] || '';
        this.horaAlteracaoValorApuracao = partes[1]?.substring(0, 5) || '';
      }
      this.dialog = true;
    },
    close() {
      if (!this.bloquearJustificativa) {
        this.$refs.formJustificativa.reset();
      }
      this.dtaAlteracaoValorApuracao = '';
      this.horaAlteracaoValorApuracao = '';
      this.dialog = false;
    },
    afirmativo() {
      if (!!this.justificativa && this.justificativa.trim() === '') {
        this.justificativa = null;
      }
      if (!this.$refs.formJustificativa.validate()) {
        return;
      }
      this.notaDebito.justificativa = this.justificativa;
      this.$emit('ModalJustificativa__afirmativo');
      this.close();
    },
    cancelar() {
      this.close();
      this.$emit('cancelar');
    },
  },
};
</script>
<style lang="scss">
.justify {
  text-align: justify;
}
</style>
